import React from "react";
import { Container } from "react-bootstrap";

export default function ContactUs() {
  return (
    <Container className="py-5">
      <h2>Contact Us</h2>
      <p className="mt-3">
        Have questions or need support? We’d love to hear from you!
      </p>
      <p>
        <strong>Email:</strong>{" "}
        <a href="mailto:contact@ticktickgo.in">contact@ticktickgo.in</a>
      </p>
      <p>
        <strong>Phone:</strong>{" "}
        <a href="tel:+917388905555">+91 7388905555</a>
      </p>
      <p>
        Our support team is available Monday–Saturday from 9:00 AM to 6:00 PM IST.
      </p>
    </Container>
  );
}
